module.exports = __webpack_public_path__ + "static/avatar_ml-3ff8d3f778b81335735838666a4e2592.png";